import { useTranslation } from 'react-i18next'

import PlainNav, { NavItem } from 'app/common/ui/PlainNav'

import styles from './FinancesSubNavigation.scss'

type Props = {
  baseUrl: string
}

const FinancesSubNavigation = ({ baseUrl }: Props) => {
  const { t } = useTranslation('finances')

  const [history = 'История финансов', paymentOrders = 'Квитанции'] = t('finances_subnav', {
    returnObjects: true,
  }) as [string, string]

  return (
    <PlainNav className={styles.root}>
      <NavItem to={`${baseUrl}/finances`}>{history}</NavItem>
      <NavItem to={`${baseUrl}/paymentOrders`}>{paymentOrders}</NavItem>
    </PlainNav>
  )
}

export default FinancesSubNavigation
